module.exports = __webpack_public_path__ + "static/media/animal_world.147218e7.jpg";